import {registerRoute as workbox_routing_registerRoute} from '/app/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkOnly as workbox_strategies_NetworkOnly} from '/app/node_modules/workbox-strategies/NetworkOnly.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/app/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/app/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/app/node_modules/workbox-strategies/CacheFirst.mjs';
import {enable as workbox_navigation_preload_enable} from '/app/node_modules/workbox-navigation-preload/enable.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/app/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/app/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */

importScripts(
  "/push-sw.js");

workbox_navigation_preload_enable();

self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "pwa-512x512.png",
    "revision": "9672339ef549bf61e972bb7809e1cd7e"
  },
  {
    "url": "pwa-192x192.png",
    "revision": "32fed317f42760adae7b65370acc5164"
  },
  {
    "url": "push-sw.js",
    "revision": "76582b38d6624d3ac8a28ee16d18de4a"
  },
  {
    "url": "og.webp",
    "revision": "f34999d8422c9c624a2c179f3cb4241a"
  },
  {
    "url": "logo.webp",
    "revision": "dd3a5589d28720ce0c43bdc04af66644"
  },
  {
    "url": "logo.png",
    "revision": "ff3817dd8254cf1afb1f18dbd17d87ba"
  },
  {
    "url": "favicon.ico",
    "revision": "1dbec25dea715660a655121a1c3a6251"
  },
  {
    "url": "default-og-image.webp",
    "revision": "f34999d8422c9c624a2c179f3cb4241a"
  },
  {
    "url": "fonts/zain-900-latin.woff2",
    "revision": "429360328e8df822f5fcc8e801dfba44"
  },
  {
    "url": "fonts/zain-400-latin.woff2",
    "revision": "d1b7c95c8eb38d704d7411397f4e5e75"
  },
  {
    "url": "fonts/plus-jakarta-sans-latin.woff2",
    "revision": "7660bd9909fb097989b19471a75f1b7a"
  },
  {
    "url": "fonts/edo.woff2",
    "revision": "5283c96caad90581cf9415d7ec3c3942"
  },
  {
    "url": "assets/zod-form-ZTeBEQWF.js",
    "revision": null
  },
  {
    "url": "assets/zap-By-1aEkp.js",
    "revision": null
  },
  {
    "url": "assets/valueToPercent-D6x5X5ZG.js",
    "revision": null
  },
  {
    "url": "assets/utils-CogJJavx.js",
    "revision": null
  },
  {
    "url": "assets/users.zod-CWMMj8Ra.js",
    "revision": null
  },
  {
    "url": "assets/users-Vi-bTOi6.js",
    "revision": null
  },
  {
    "url": "assets/users-CVaWhX_B.js",
    "revision": null
  },
  {
    "url": "assets/useUserAvailableGroups-BRCxfmV3.js",
    "revision": null
  },
  {
    "url": "assets/useTournamentAdminAction-o0g8Jmk8.js",
    "revision": null
  },
  {
    "url": "assets/usePushOptInPrompt-od_gd7GM.js",
    "revision": null
  },
  {
    "url": "assets/useLevels-CECV6PDC.js",
    "revision": null
  },
  {
    "url": "assets/useDebounce-Bo-MD7W4.js",
    "revision": null
  },
  {
    "url": "assets/useDeadline-DbZUpuhf.js",
    "revision": null
  },
  {
    "url": "assets/useAriaLabelledBy-DCUHSOvB.js",
    "revision": null
  },
  {
    "url": "assets/useAnalyticsPageView-DAGoUCt4.js",
    "revision": null
  },
  {
    "url": "assets/upload-BGoYRDha.js",
    "revision": null
  },
  {
    "url": "assets/trending-up-eBDYMt1F.js",
    "revision": null
  },
  {
    "url": "assets/trash-2-HvPo-32Q.js",
    "revision": null
  },
  {
    "url": "assets/transactions-FdC-1-p3.js",
    "revision": null
  },
  {
    "url": "assets/trainings-ClGcmweV.js",
    "revision": null
  },
  {
    "url": "assets/tournaments-VI-yC16F.js",
    "revision": null
  },
  {
    "url": "assets/tournaments-D1tPC-vj.js",
    "revision": null
  },
  {
    "url": "assets/tournament-status-CKoxgaQp.js",
    "revision": null
  },
  {
    "url": "assets/tournament-seats-DAmlBIc8.js",
    "revision": null
  },
  {
    "url": "assets/tournament-admin-BNyP6Ans.js",
    "revision": null
  },
  {
    "url": "assets/tooltip-button-Bcml-dJW.js",
    "revision": null
  },
  {
    "url": "assets/toggle-group-BpKXkisB.js",
    "revision": null
  },
  {
    "url": "assets/ticket-x-C1ZRv8Tz.js",
    "revision": null
  },
  {
    "url": "assets/textarea-C34PqvQd.js",
    "revision": null
  },
  {
    "url": "assets/terms-of-service-BKxdCoJW.js",
    "revision": null
  },
  {
    "url": "assets/teams-Bj2n5fd9.js",
    "revision": null
  },
  {
    "url": "assets/tabs-BcU4bokm.js",
    "revision": null
  },
  {
    "url": "assets/table-pagination-BR3t5x2X.js",
    "revision": null
  },
  {
    "url": "assets/table-DVr2h5RS.js",
    "revision": null
  },
  {
    "url": "assets/switch-CTOnactI.js",
    "revision": null
  },
  {
    "url": "assets/stripe-XNVbMSMg.js",
    "revision": null
  },
  {
    "url": "assets/stripe-BSHUFByF.js",
    "revision": null
  },
  {
    "url": "assets/stringifyLocale-D5LpcRk6.js",
    "revision": null
  },
  {
    "url": "assets/star-CK8MSGkL.js",
    "revision": null
  },
  {
    "url": "assets/sparkles-DH0jRRW9.js",
    "revision": null
  },
  {
    "url": "assets/slider-BdVg_uPD.js",
    "revision": null
  },
  {
    "url": "assets/showcase_6-BZ7JWBV_.webp",
    "revision": null
  },
  {
    "url": "assets/showcase_4-CNrQV3Bz.webp",
    "revision": null
  },
  {
    "url": "assets/showcase_3-Cuc7VBiG.webp",
    "revision": null
  },
  {
    "url": "assets/showcase_2-K-NajMuK.webp",
    "revision": null
  },
  {
    "url": "assets/showcase_1-YrYELUM-.webp",
    "revision": null
  },
  {
    "url": "assets/sheet-KoEFgQFd.js",
    "revision": null
  },
  {
    "url": "assets/settings-CYgpvLXw.js",
    "revision": null
  },
  {
    "url": "assets/settings-B5Z8leMr.js",
    "revision": null
  },
  {
    "url": "assets/session-reports-1fxpNCvz.js",
    "revision": null
  },
  {
    "url": "assets/sentry-DpATYX8W.js",
    "revision": null
  },
  {
    "url": "assets/routes-Dt1co-6x.js",
    "revision": null
  },
  {
    "url": "assets/route-DI5FBcpt.js",
    "revision": null
  },
  {
    "url": "assets/route-CLlF8rj6.js",
    "revision": null
  },
  {
    "url": "assets/route-B2iJTbPO.js",
    "revision": null
  },
  {
    "url": "assets/rolldown-runtime-B7BvoAjS.js",
    "revision": null
  },
  {
    "url": "assets/report-aB0hI53d.js",
    "revision": null
  },
  {
    "url": "assets/repeat-DdPJD-lx.js",
    "revision": null
  },
  {
    "url": "assets/registrations-C0rBaDXE.js",
    "revision": null
  },
  {
    "url": "assets/react-markdown-CFV2RaPi.js",
    "revision": null
  },
  {
    "url": "assets/radio-group-DTCl_8SD.js",
    "revision": null
  },
  {
    "url": "assets/purchases-ot7CCTOa.js",
    "revision": null
  },
  {
    "url": "assets/progress-BfWqaxLG.js",
    "revision": null
  },
  {
    "url": "assets/profiles-yiKC-R2c.js",
    "revision": null
  },
  {
    "url": "assets/privacy-policy-D5O_2mOH.js",
    "revision": null
  },
  {
    "url": "assets/printer-D6AKeSZC.js",
    "revision": null
  },
  {
    "url": "assets/posthog-BYQPHzWH.js",
    "revision": null
  },
  {
    "url": "assets/phone-KBfpEVzK.js",
    "revision": null
  },
  {
    "url": "assets/period-picker-B0p3AMCF.js",
    "revision": null
  },
  {
    "url": "assets/pencil-FXZyKwfx.js",
    "revision": null
  },
  {
    "url": "assets/page-header-BIIe4tV5.js",
    "revision": null
  },
  {
    "url": "assets/packs-D22jHgoL.js",
    "revision": null
  },
  {
    "url": "assets/package-CqMBvXF0.js",
    "revision": null
  },
  {
    "url": "assets/octagon-alert-DLhYM4sC.js",
    "revision": null
  },
  {
    "url": "assets/nif-D7F8suMx.js",
    "revision": null
  },
  {
    "url": "assets/navigator-BNSPREMf.js",
    "revision": null
  },
  {
    "url": "assets/message-square-DCUtmaJl.js",
    "revision": null
  },
  {
    "url": "assets/membership-CoakHsDr.js",
    "revision": null
  },
  {
    "url": "assets/map-vh-t_kPv.css",
    "revision": null
  },
  {
    "url": "assets/map-pin-DxV9Bbht.js",
    "revision": null
  },
  {
    "url": "assets/map-hUL-ySHE.js",
    "revision": null
  },
  {
    "url": "assets/manage-f0LA9iXN.js",
    "revision": null
  },
  {
    "url": "assets/manage-_NnglEUf.js",
    "revision": null
  },
  {
    "url": "assets/logo-lMIGbIpK.webp",
    "revision": null
  },
  {
    "url": "assets/label-CcrrN7lQ.js",
    "revision": null
  },
  {
    "url": "assets/iso-wtGsF7UE.js",
    "revision": null
  },
  {
    "url": "assets/invitations-C_MmrD8U.js",
    "revision": null
  },
  {
    "url": "assets/invitations-CHmaI33B.js",
    "revision": null
  },
  {
    "url": "assets/index-DezWK-J3.css",
    "revision": null
  },
  {
    "url": "assets/index-8_FdEcDA.js",
    "revision": null
  },
  {
    "url": "assets/import-ZbC8LLZh.js",
    "revision": null
  },
  {
    "url": "assets/impact-Bet8_E0P.js",
    "revision": null
  },
  {
    "url": "assets/home-DsG78NC1.js",
    "revision": null
  },
  {
    "url": "assets/history-DMzXyfus.js",
    "revision": null
  },
  {
    "url": "assets/heic2any-QT7G4zZB.js",
    "revision": null
  },
  {
    "url": "assets/heart-lvdzjrEE.js",
    "revision": null
  },
  {
    "url": "assets/hand-heart-CrVwM_Lo.js",
    "revision": null
  },
  {
    "url": "assets/groups-DWMWzRGT.js",
    "revision": null
  },
  {
    "url": "assets/groups-CJaViT-H.js",
    "revision": null
  },
  {
    "url": "assets/free-agents-CNX4MDFR.js",
    "revision": null
  },
  {
    "url": "assets/form-CGEvVIme.js",
    "revision": null
  },
  {
    "url": "assets/finance-DO3OCGVJ.js",
    "revision": null
  },
  {
    "url": "assets/finance-CqYeSfi_.js",
    "revision": null
  },
  {
    "url": "assets/feedback-DoF50tnJ.js",
    "revision": null
  },
  {
    "url": "assets/eye-DotFQ-7B.js",
    "revision": null
  },
  {
    "url": "assets/external-link-Bi8QG6tw.js",
    "revision": null
  },
  {
    "url": "assets/events-JoWquX_O.js",
    "revision": null
  },
  {
    "url": "assets/eventGrouping-DhCq6qLI.js",
    "revision": null
  },
  {
    "url": "assets/event-utils-DAMVZT5s.js",
    "revision": null
  },
  {
    "url": "assets/event-series-CdoVcMVS.js",
    "revision": null
  },
  {
    "url": "assets/event-feedback-Bj7j6Uqf.js",
    "revision": null
  },
  {
    "url": "assets/event-COK1B_OT.js",
    "revision": null
  },
  {
    "url": "assets/euro-CCUqoegf.js",
    "revision": null
  },
  {
    "url": "assets/errors-na1nnrGM.js",
    "revision": null
  },
  {
    "url": "assets/empty_state-DjwJEU__.webp",
    "revision": null
  },
  {
    "url": "assets/empty_state-5jfMs-I6.webp",
    "revision": null
  },
  {
    "url": "assets/empty-BjufTEWe.js",
    "revision": null
  },
  {
    "url": "assets/ellipsis-B_t_7TYl.js",
    "revision": null
  },
  {
    "url": "assets/droplets-Dz5j1b6Q.js",
    "revision": null
  },
  {
    "url": "assets/door-open-t6uXgYyZ.js",
    "revision": null
  },
  {
    "url": "assets/dist-DsQ2bwJi.js",
    "revision": null
  },
  {
    "url": "assets/dialog-DrsQxkr8.js",
    "revision": null
  },
  {
    "url": "assets/date-picker-DuCWwtXN.js",
    "revision": null
  },
  {
    "url": "assets/data-table-Dd1-r5pV.js",
    "revision": null
  },
  {
    "url": "assets/coupons-nlk_oLNk.js",
    "revision": null
  },
  {
    "url": "assets/coupons-CovXfTsM.js",
    "revision": null
  },
  {
    "url": "assets/copy-DSlq8IMA.js",
    "revision": null
  },
  {
    "url": "assets/constants-BQRbwAkd.js",
    "revision": null
  },
  {
    "url": "assets/confirm-dialog-pAQ9h_SW.js",
    "revision": null
  },
  {
    "url": "assets/command-Fz7S8wZv.js",
    "revision": null
  },
  {
    "url": "assets/color-Btyml2yr.js",
    "revision": null
  },
  {
    "url": "assets/coerce-BcB5i2ml.js",
    "revision": null
  },
  {
    "url": "assets/coaches-BEpFzzBm.js",
    "revision": null
  },
  {
    "url": "assets/circle-question-mark-CIRY0WzF.js",
    "revision": null
  },
  {
    "url": "assets/circle-alert-So9KK-bE.js",
    "revision": null
  },
  {
    "url": "assets/checkbox-BWvSLD-P.js",
    "revision": null
  },
  {
    "url": "assets/chart-Dx_ihnZ4.js",
    "revision": null
  },
  {
    "url": "assets/card-NRXSc48O.js",
    "revision": null
  },
  {
    "url": "assets/calendar-range-CbZUZ7yj.js",
    "revision": null
  },
  {
    "url": "assets/calendar-CNz7FH_p.js",
    "revision": null
  },
  {
    "url": "assets/auth-Nq-xkzMh.js",
    "revision": null
  },
  {
    "url": "assets/arrow-up-down-DqPbzL7J.js",
    "revision": null
  },
  {
    "url": "assets/arrow-up-CzBjzybE.js",
    "revision": null
  },
  {
    "url": "assets/arrow-right-Cfc0AtAs.js",
    "revision": null
  },
  {
    "url": "assets/arrow-left-CMBSwNa5.js",
    "revision": null
  },
  {
    "url": "assets/arrow-down-C_iaHXvA.js",
    "revision": null
  },
  {
    "url": "assets/alert-Wnh_jDkk.js",
    "revision": null
  },
  {
    "url": "assets/activity-DiIAUZiu.js",
    "revision": null
  },
  {
    "url": "assets/_username-BNL_MKYs.js",
    "revision": null
  },
  {
    "url": "assets/_tournamentId-_Y_faXLe.js",
    "revision": null
  },
  {
    "url": "assets/_seriesId-Be1ovbnn.js",
    "revision": null
  },
  {
    "url": "assets/_purchaseId-C4jOOTyM.js",
    "revision": null
  },
  {
    "url": "assets/UserSimple-DZJDYvuJ.js",
    "revision": null
  },
  {
    "url": "assets/Trans-lzSiuuFF.js",
    "revision": null
  },
  {
    "url": "assets/TournamentAdminShell-B_vhmcMS.js",
    "revision": null
  },
  {
    "url": "assets/StripeProductSelect-BkKiOIOK.js",
    "revision": null
  },
  {
    "url": "assets/StripeIntentShared-BI6KYYGb.js",
    "revision": null
  },
  {
    "url": "assets/StripeIntentPanel-B8odCecx.js",
    "revision": null
  },
  {
    "url": "assets/StatDelta-G-RF7MZ8.js",
    "revision": null
  },
  {
    "url": "assets/SessionPacksManagementDialog-CUFXlDlI.js",
    "revision": null
  },
  {
    "url": "assets/SeriesFormSheet-Dm5Rg9wG.js",
    "revision": null
  },
  {
    "url": "assets/QuickEventCreateDialog-Cd3kYxqd.js",
    "revision": null
  },
  {
    "url": "assets/PricingSection-CaLAgtkZ.js",
    "revision": null
  },
  {
    "url": "assets/PaymentRecoverySummary-BQcfohJa.js",
    "revision": null
  },
  {
    "url": "assets/PaymentBadge-9Cs7GSnt.js",
    "revision": null
  },
  {
    "url": "assets/OnboardingDialog-BwotWH9h.js",
    "revision": null
  },
  {
    "url": "assets/MessagePlayersDialog-CcaYWcHN.js",
    "revision": null
  },
  {
    "url": "assets/MarkdownRenderer-CEMyQpbo.js",
    "revision": null
  },
  {
    "url": "assets/LocationMapDisplay-DDht3OUx.js",
    "revision": null
  },
  {
    "url": "assets/LocationMap-B1R-R0oA.js",
    "revision": null
  },
  {
    "url": "assets/ImageSection-BUXidg1g.js",
    "revision": null
  },
  {
    "url": "assets/HelpSection-B2UjAP6u.js",
    "revision": null
  },
  {
    "url": "assets/FinanceRevenueChart-_kf3RH48.js",
    "revision": null
  },
  {
    "url": "assets/FieldItemContext-I3a6a3ch.js",
    "revision": null
  },
  {
    "url": "assets/EventSimple-CLqJ696v.js",
    "revision": null
  },
  {
    "url": "assets/EventFormSheet-D2i9cpQB.js",
    "revision": null
  },
  {
    "url": "assets/EventCard-zPXwAKO-.js",
    "revision": null
  },
  {
    "url": "assets/EventAvatar-BNtNaXgM.js",
    "revision": null
  },
  {
    "url": "assets/EmptyTimeline-C3AsKwYG.js",
    "revision": null
  },
  {
    "url": "assets/DialogRoot-BV_cKgsi.js",
    "revision": null
  },
  {
    "url": "assets/DialogPopup-C2Sf5sLF.js",
    "revision": null
  },
  {
    "url": "assets/CoachesAutocomplete-B4xCp9bI.js",
    "revision": null
  },
  {
    "url": "assets/AuthForm-CY-kW-Jp.js",
    "revision": null
  },
  {
    "url": "assets/AthleteFlagBadge-C61FNkZr.js",
    "revision": null
  },
  {
    "url": "assets/AnnouncementManagementDialog-DxHGAPAG.js",
    "revision": null
  },
  {
    "url": "assets/AdminPageHeader-THrByJo8.js",
    "revision": null
  },
  {
    "url": "favicon.ico",
    "revision": "1dbec25dea715660a655121a1c3a6251"
  },
  {
    "url": "logo.png",
    "revision": "ff3817dd8254cf1afb1f18dbd17d87ba"
  },
  {
    "url": "pwa-192x192.png",
    "revision": "32fed317f42760adae7b65370acc5164"
  },
  {
    "url": "pwa-512x512.png",
    "revision": "9672339ef549bf61e972bb7809e1cd7e"
  },
  {
    "url": "site.webmanifest",
    "revision": "63baf8f9f7d9d28d2b0d4ae447f5cb48"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();
workbox_routing_registerRoute(({ request }) => request.mode === "navigate", new workbox_strategies_NetworkOnly(), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.googleapis\.com\/.*/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"google-fonts-stylesheets", plugins: [] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.gstatic\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts-webfonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 30, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/.*bunnycdn\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"cdn-images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 200, maxAgeSeconds: 2592000 })] }), 'GET');


